module.exports = __webpack_public_path__ + "static/eToro-banner-a7fcccb6b85a8aba4e66578d0560304f.png";